// Dependencias generales
import React from "react"
import { useEffect, useState } from 'react'
import InitialConfigHeader from '../../../components/InitialConfig/UserInitialConfigHeader'
import StepIntro from '../../../components/InitialConfig/StepIntro'
import AsideMenu from '../../../components/InitialConfig/AsideMenu'
import AppLogoImg from '../../../components/Utils/AppLogoImg'
import Loader from '../../../components/Utils/Loader'
import WorkflowNavigationButtons from '../../../components/InitialConfig/WorkflowNavigationButtons'
import WorkflowIlustration from "../../../components/InitialConfig/WorkflowIlustration"
import FormValidationError from "../../../components/InitialConfig/FormValidationError"
import ReactGA from "react-ga4";

const endpointHelias = "https://9m4y8iz04h.execute-api.eu-west-3.amazonaws.com/prod"
const updateInstallationConfiguration = endpointHelias+"/Helias/V0/Configuration/updateInstallationConfiguration"
const getInstallationConfiguration = endpointHelias+"/Helias/V0/Configuration/getInstallationConfiguration"

var initialConfigCommonJS = require("../../../js/initialConfigCommon.js")
var dashboardCommonJS = require("../../../js/dashboardCommon.js");
var generalCommonJS = require("../../../js/generalCommon.js")

// Initial config - FV
const Fv = () => {

  const [selectedLocation, setSelectedLocation] = useState([{ id: "", distance: "", lat: "40.4167754", long: "-3.7037902" }]) //Default Madrid

  useEffect(() => {    

    if(initialConfigCommonJS.antiBackOnboarding() === false){
      
      if(localStorage.getItem("installationConfigurationMode") === null){
        localStorage.removeItem("currentInstallationConfiguration")
        localStorage.removeItem("configuredApps")
        generalCommonJS.registrarEventoAnalitica(ReactGA, 'REGISTRO', 'REGISTRO - FV', "", "")
      }

      initialConfigCommonJS.actualizarPasoWorkflowEnBBDD("FV")
      
      if(localStorage.getItem("currentInstallationConfiguration") !== null){        
        procesarConfiguracionActual(JSON.parse(localStorage.getItem("currentInstallationConfiguration")))
      }
      else{
        cargarConfiguracionActualPaso()        
      }
      
      if(localStorage.getItem("installationConfigurationMode") !== null){
        document.getElementById("fv").className = "step"
        initialConfigCommonJS.visibilidadModoConfiguracion()
        document.getElementById("initialConfigBreadcrumb").className = document.getElementById("initialConfigBreadcrumb").className.replaceAll(" hidden", "") + " hidden"        

      }
      else{
        document.title = "HELIAS - Configuración inicial: Paneles solares"
      }
    }
    
  }, []);

  const [illustrationElements, setIllustrationElements] = useState([])
  const [appSensorFV, setAppSensorFV] = useState("")

  function procesarConfiguracionActual(jsonRespuesta){
    
    if(jsonRespuesta.FV.toString().length > 0){          

      var configuracionPasoActual = jsonRespuesta.FV
      
      document.getElementById("potenciaMaximaFV").value = configuracionPasoActual.FVMaxGeneration
      
      //Cargo la combo del sensor de FV            
      if(configuracionPasoActual.MainFVSensor !== ""){

          var datosSensorFV = configuracionPasoActual.MainFVSensor.split("|")              
          setAppSensorFV(datosSensorFV[0]) 
          document.getElementById("sensorFVSpan").innerHTML = datosSensorFV[datosSensorFV.length-1]
          document.getElementById("sensorFV").value = datosSensorFV[0]+"|"+datosSensorFV[1]+"|"+datosSensorFV[2]

          document.getElementById("sensorFVFieldsetSinConfigurar").style="display: none"
          document.getElementById("sensorFVFieldsetSeleccionado").style="display"

      }
      else{
        document.getElementById("selectTipoInstalacionFV").value = "SOLARPACK"
        actualizarFormulario()            
      }

      if(jsonRespuesta.GeneralInfo.EnergyGridConnected === "false"){
        document.getElementById("fieldsetPrecioVenta").className += " hidden"
        document.getElementById("precioVentaKwFV").value = ""                
        document.getElementById("fieldsetTipoTarifa").className = document.getElementById("fieldsetTipoTarifa").className.replaceAll(" hidden", "") + " hidden"
        document.getElementById("selectTipoTarifa").value = "INDEXADA"
        document.getElementById("fieldsetMonederoSolar").className = document.getElementById("fieldsetMonederoSolar").className.replaceAll(" hidden", "") + " hidden"
        document.getElementById("fieldsetSubvencion").className = document.getElementById("fieldsetSubvencion").className.replaceAll(" hidden", "") + " hidden"
      }
      else{                
        document.getElementById("fieldsetPrecioVenta").className = document.getElementById("fieldsetPrecioVenta").className.replaceAll(" hidden", "")
        document.getElementById("precioVentaKwFV").value = configuracionPasoActual.EnergySellPrice
        document.getElementById("selectTipoTarifa").value = configuracionPasoActual.SellFeeType
        if(configuracionPasoActual.SellFeeType === "FIJA"){
          document.getElementById("fieldsetPrecioVenta").className = document.getElementById("fieldsetPrecioVenta").className.replaceAll(" hidden", "")
        }
        else{
          document.getElementById("fieldsetPrecioVenta").className = document.getElementById("fieldsetPrecioVenta").className.replaceAll(" hidden", "") + " hidden"
        }
      }

      if(configuracionPasoActual.SolarWallet === "true"){
        document.getElementById("checkboxMonederoSolar").checked = true   
        document.getElementById("fechaDesdeActivacionMonedero").value = configuracionPasoActual.SolarWalletActivationDate                
        document.getElementById("saldoMonederoConfiguracionInicial").value = configuracionPasoActual.SolarWalletInitialBalance      
        if(configuracionPasoActual.SolarWalletFree === "true"){
          document.getElementById("checkboxMonederoSolarGratis").checked = true
        }
        else{
          document.getElementById("checkboxMonederoSolarGratis").checked = false
        }      
        if(configuracionPasoActual.PartialCompensation === "true"){
          console.log("1")
          document.getElementById("checkboxCompensacionParcialExcedentes").checked = true
        }
        else{
          console.log("2")
          document.getElementById("checkboxCompensacionParcialExcedentes").checked = false
        }    
      }
      else{
        document.getElementById("checkboxMonederoSolar").checked = false
        document.getElementById("fechaDesdeActivacionMonedero").value = ""
        document.getElementById("saldoMonederoConfiguracionInicial").value = ""
        document.getElementById("checkboxMonederoSolarGratis").checked = false   
      }
      
      visibilidadOpcionesMonedero()              

      if(configuracionPasoActual.FVSubsidy === "true"){
        document.getElementById("checkboxSubvencion").checked = true
      }
      else{
        document.getElementById("checkboxSubvencion").checked = false
      }            

      document.getElementById("botonEliminarConfiguracion").className = document.getElementById("botonEliminarConfiguracion").className.replaceAll(" hidden", "")

    }              
    else{

      if(jsonRespuesta.GeneralInfo.EnergyGridConnected === "false"){
        document.getElementById("fieldsetPrecioVenta").className += " hidden"
        document.getElementById("precioVentaKwFV").value = ""                
        document.getElementById("fieldsetTipoTarifa").className = document.getElementById("fieldsetTipoTarifa").className.replaceAll(" hidden", "") + " hidden"
        document.getElementById("selectTipoTarifa").value = "INDEXADA"
        document.getElementById("fieldsetMonederoSolar").className = document.getElementById("fieldsetMonederoSolar").className.replaceAll(" hidden", "") + " hidden"

      }
      else{
        document.getElementById("fieldsetPrecioVenta").className = document.getElementById("fieldsetPrecioVenta").className.replaceAll(" hidden", "")
        
        if(configuracionPasoActual !== undefined){ 
          document.getElementById("precioVentaKwFV").value = configuracionPasoActual.EnergySellPrice 
          document.getElementById("selectTipoTarifa").value = configuracionPasoActual.SellFeeType

          if(configuracionPasoActual.SellFeeType === "FIJA"){
            document.getElementById("fieldsetPrecioVenta").className = document.getElementById("fieldsetPrecioVenta").className.replaceAll(" hidden", "")
          }
          else{
            document.getElementById("fieldsetPrecioVenta").className = document.getElementById("fieldsetPrecioVenta").className.replaceAll(" hidden", "") + " hidden"
          }

        }
        else{ 
          document.getElementById("precioVentaKwFV").value = "" 
        }

      }

    }                     
 
  setIllustrationElements(initialConfigCommonJS.cargaInicialIlustracion(jsonRespuesta))

  //Si no hay datos configurados entonces no hago nada 
 
  }

  function cargarConfiguracionActualPaso(){

    var lastAuthUser = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser")
    var lastAuthUserIdToken = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74."+lastAuthUser+".idToken")    
    var ongoingInstallationConfigurationID = localStorage.getItem("ongoingInstallationConfiguration")    

    //Petición de datos para el paso actual
    var jsonPeticion = {
      "accountID": localStorage.getItem("accountID"),
      "installationID": ongoingInstallationConfigurationID,    
      "GeneralInfo": "",
      "Meteo": "",
      "FV": "",
      "Battery": "",
      "Generator": "",
      "Cars": "",
      "Messaging": ""
    }
  
    // Guardo la información  
    var xhttp = new XMLHttpRequest();  
      xhttp.open("POST", getInstallationConfiguration, true);        
      xhttp.setRequestHeader('Content-Type', "application/json");
      xhttp.setRequestHeader('Authorization', lastAuthUserIdToken);
      var data = JSON.stringify(jsonPeticion);
      xhttp.onreadystatechange = function() {
        
        if (this.readyState === 4 && this.status === 200) {
          var jsonRespuesta = JSON.parse(this.responseText)
          if(jsonRespuesta.statusCode === "403"){                   
            initialConfigCommonJS.mostrarMensajeInformativo("No tiene permisos para realizar la operación.","negative")
          }
          else{          
            procesarConfiguracionActual(jsonRespuesta.body)
            console.log("Información cargada correctamente")
          }   
        }
  
        if (this.readyState === 4 && this.status !== 200) {                          
          initialConfigCommonJS.gestionarRespuestaPeticionErronea(this.status)               
        }
      }
      xhttp.send(data);      
  }

  function actualizarFormulario(){

    if(document.getElementById("selectTipoInstalacionFV").value === "PANELES"){
      document.getElementById("formularioFV").className = document.getElementById("formularioFV").className.replaceAll(" hidden","")
      document.getElementById("sensorFVFieldsetSinConfigurar").className =  document.getElementById("sensorFVFieldsetSinConfigurar").className.replaceAll(" hidden","")
      document.getElementById("sensorFVFieldsetSeleccionado").className = document.getElementById("sensorFVFieldsetSeleccionado").className.replaceAll(" hidden","")
    }
    else{
      document.getElementById("formularioFV").className += " hidden"
      document.getElementById("sensorFVFieldsetSinConfigurar").className += " hidden"
      document.getElementById("sensorFVFieldsetSeleccionado").className += " hidden"
      document.getElementById("sensorFV").value = "SOLARPACK"
    }

  }
  
  function validacionCamposCorrecta(){

    var numeroErroresValidacion = 0

    document.getElementById("potenciaMaximaFV").className = ""      
    document.getElementById("precioVentaKwFV").className = ""      
    document.getElementById("sensorFVLink").className = "link"          
    document.getElementById("fechaDesdeActivacionMonedero").className = ""
    document.getElementById("saldoMonederoConfiguracionInicial").className = ""

    if(document.getElementById("potenciaMaximaFV").value === ""){
      numeroErroresValidacion++
      document.getElementById("potenciaMaximaFV").className = "error"
    }

    if(document.getElementById("sensorFV").value === ""){
      numeroErroresValidacion++
      document.getElementById("sensorFVLink").className += " error"
    }

    if(document.getElementById("selectTipoTarifa").value === "FIJA"){
      
      document.getElementById("precioVentaKwFV").value = document.getElementById("precioVentaKwFV").value.replaceAll(" ","").replaceAll(",",".")

      if(document.getElementById("precioVentaKwFV").value === ""){
        numeroErroresValidacion++
        document.getElementById("precioVentaKwFV").className = "error"
      }
      else if(parseFloat(document.getElementById("precioVentaKwFV").value) > 0.5){
        initialConfigCommonJS.mostrarMensajeInformativo("La tarifa introducida es incorrecta. Normalmente son valores de céntimos inferiores a 0,5€.","negative")
        numeroErroresValidacion++
        document.getElementById("precioVentaKwFV").className = "error"
      }

    }
   
    if(document.getElementById("checkboxMonederoSolar").checked === true){
      if(document.getElementById("fechaDesdeActivacionMonedero").value === ""){
        numeroErroresValidacion++
        document.getElementById("fechaDesdeActivacionMonedero").className = "error"
      }      
    }    

    if(numeroErroresValidacion > 0){      
      document.getElementById("divErrorValidacionFormulario").className="message error left"
      return false
    }
    else{
      document.getElementById("divErrorValidacionFormulario").className="message error left hidden"
      return true
    }

  }

  function guardarInformacionPaso(direccion){
    
    var lastAuthUser = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser")
    var lastAuthUserIdToken = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74."+lastAuthUser+".idToken")    
    var ongoingInstallationConfigurationID = localStorage.getItem("ongoingInstallationConfiguration")  
    
    document.getElementById("loaderFV").className="loader overlay"
  
    var sensorFV = ""
    if(document.getElementById("sensorFV").value !== ""){
      sensorFV = document.getElementById("sensorFV").value+"|"+document.getElementById("sensorFVSpan").innerHTML
    }

    if(document.getElementById("selectTipoInstalacionFV").value !== "PANELES"){
      document.getElementById("potenciaMaximaFV").value = ""
      document.getElementById("precioVentaKwFV").value = ""   
      sensorFV = ""   
    }

    var monederoSolar = "false"
    var monederoSolarGratuito = "false"
    var fechaActivacionMonederoSolar = ""
    var saldoInicialMonedero = ""

    if(document.getElementById("checkboxMonederoSolar").checked === true){
      monederoSolar = "true"
      fechaActivacionMonederoSolar = document.getElementById("fechaDesdeActivacionMonedero").value
      if(document.getElementById("saldoMonederoConfiguracionInicial").value === ""){
        saldoInicialMonedero = "0"
      }
      else{
        saldoInicialMonedero = document.getElementById("saldoMonederoConfiguracionInicial").value
      }
      
    }
    else{
      monederoSolar = "false"
      fechaActivacionMonederoSolar = ""
      saldoInicialMonedero = ""
    }

    if(document.getElementById("checkboxMonederoSolarGratis").checked === true){ monederoSolarGratuito = "true" }
    else{ monederoSolarGratuito = "false" }

    var subvencion = "false"

    if(document.getElementById("checkboxSubvencion").checked === true){
      subvencion = "true"
    }
    else{
      subvencion = "false"
    }

    var compensacionExcedentesParcial = "false"

    if(document.getElementById("checkboxCompensacionParcialExcedentes").checked === true){
      console.log("3")
      compensacionExcedentesParcial = "true"
    }
    else{
      console.log("4")
      compensacionExcedentesParcial = "false"
    }

    var jsonFV = {
      "FVType": document.getElementById("selectTipoInstalacionFV").value,
      "FVMaxGeneration": document.getElementById("potenciaMaximaFV").value.replaceAll(",","."),
      "SellFeeType": document.getElementById("selectTipoTarifa").value,
      "EnergySellPrice": document.getElementById("precioVentaKwFV").value.replaceAll(",","."),    
      "FVSubsidy": subvencion,
      "SolarWallet": monederoSolar,
      "SolarWalletFree": monederoSolarGratuito,
      "PartialCompensation": compensacionExcedentesParcial,      
      "SolarWalletActivationDate": fechaActivacionMonederoSolar,
      "SolarWalletInitialBalance": saldoInicialMonedero.replaceAll(",","."),
      "MainFVSensor": sensorFV
    }
  
    var jsonGuardado = {
      "accountID": localStorage.getItem("accountID"),
      "installationID": ongoingInstallationConfigurationID,
      "FV": jsonFV
    }
  
    // Guardo la información  
    var xhttp = new XMLHttpRequest();  
      xhttp.open("POST", updateInstallationConfiguration, true);        
      xhttp.setRequestHeader('Content-Type', "application/json");
      xhttp.setRequestHeader('Authorization', lastAuthUserIdToken);
      var data = JSON.stringify(jsonGuardado);
      xhttp.onreadystatechange = function() {
        
        if (this.readyState === 4 && this.status === 200) {
          var jsonRespuestaGuardado = JSON.parse(this.responseText)
          if(jsonRespuestaGuardado.statusCode === "403"){                   
            initialConfigCommonJS.mostrarMensajeInformativo("No tiene permisos para realizar la operación.","negative")
          }
          else{          
            console.log("Información guardada correctamente")            
            
            if(localStorage.getItem("installationConfigurationMode") === null){
              if(localStorage.getItem("ongoingStepConfiguration") === "FV" ){      
                initialConfigCommonJS.navegarDinamico(direccion)
              }
              else{
                initialConfigCommonJS.mostrarMensajeInformativo('Todavía no he cargado la información para continuar, me has pillado despistao, inténtalo de nuevo ahora a ver...',"")
              }              
            }
            else{
              initialConfigCommonJS.mostrarMensajeInformativo("Configuración guardada correctamente, estoy conectándome a los sistemas configurados así que puede que los cambios tarden un par de minutos en reflejarse.","positive")

              //Si al guardar veo que el mes de activación es el actual actualizo automáticamente el saldo del monedero.
              var mesAñoActivacion = fechaActivacionMonederoSolar.substring(0,7)
              var mesAñoActual = JSON.stringify(new Date()).substring(1,8)
                            
              if(monederoSolar === "true"){
                if(mesAñoActivacion === mesAñoActual){
                  console.log("Ajusto el monedero solar automáticamente al ser el mes actual el de activación.")
                  dashboardCommonJS.ajustarMonederoSolar(fechaActivacionMonederoSolar, "0")
                }
              } 

              document.getElementById("asideDetalleConfiguracion").className += " hidden"
              document.getElementById("loaderFV").className="loader hidden"
            }
          }
        }
  
        if (this.readyState === 4 && this.status !== 200) {                          
          initialConfigCommonJS.gestionarRespuestaPeticionErronea(this.status)       
        }
      }
      xhttp.send(data);      
  }
  
  function navegar(direccion){
    if(initialConfigCommonJS.existeSesion()){
      if(direccion === "continuar"){    
        if(validacionCamposCorrecta()){
          if(document.getElementById("contenedorPrincipalOpcion") !== null){
            document.getElementById("contenedorPrincipalOpcion").scrollTop = 0
          }
          guardarInformacionPaso(direccion)
        }
      }
      else{
        if(localStorage.getItem("ongoingStepConfiguration") === "FV"){      
          initialConfigCommonJS.navegarDinamico(direccion)
        }
        else{
          initialConfigCommonJS.mostrarMensajeInformativo('Todavía no he cargado la información para continuar, me has pillado despistao, inténtalo de nuevo ahora a ver...',"")
        }
      }  
    }
  }
  
  function actualizarCampoTarifa(){
    if(document.getElementById("selectTipoTarifa").value === "FIJA"){
      document.getElementById("precioVentaKwFV").value = ""
      document.getElementById("fieldsetPrecioVenta").className = document.getElementById("fieldsetPrecioVenta").className.replaceAll(" hidden", "")
    }
    else{
      document.getElementById("precioVentaKwFV").value = ""
      document.getElementById("fieldsetPrecioVenta").className = document.getElementById("fieldsetPrecioVenta").className.replaceAll(" hidden", "") + " hidden"
    }
  }

  function visibilidadOpcionesMonedero(){
    
    if(document.getElementById("checkboxMonederoSolar").checked === true){
      document.getElementById("opcionesMonederoSolar").className = document.getElementById("opcionesMonederoSolar").className.replaceAll(" hidden", "")
    }
    else{
      document.getElementById("opcionesMonederoSolar").className = document.getElementById("opcionesMonederoSolar").className.replaceAll(" hidden", "") + " hidden"
    }

  }

  return (          
    <main id="divMainContenedorStep">      

      <InitialConfigHeader step={"FV"}/>
      
      <section id="fv" className="step wrapper">
        <div id="divContenedorStep" className="content-wrapper half">
          
          <StepIntro 
            Title="Paneles solares" 
            Intro={<>Para exprimir al máximo su rendimiento, necesito que me orientes un poco con unos datos básicos para usar de referencia.</>}            
          />          
          
          <form onSubmit={e => { e.preventDefault(); }} autoComplete="off">
          <fieldset className=" hidden">  
            <legend>¿Qué tipo de instalación fotovoltáica tienes?</legend>
            <fieldset className="dropdown">                
              <div className="icon-wrapper">
                <select id="selectTipoInstalacionFV" onChange={() => actualizarFormulario()}>
                  <option value="PANELES">Paneles solares en la instalación</option>
                  <option value="SOLARPACK">Autoconsumo paneles remotos (Solarpack)</option>                  
                </select>
              </div>
            </fieldset> 
          </fieldset>

          <fieldset id="formularioFV">
            <fieldset className="two-columns tooltip-parent">              
              <fieldset>              
                <label className="has-tooltip" htmlFor="labelPotenciaMaximaFV">  
                  <span className="label tooltip-label">Potencia máxima instalada</span>                
                  <span className="tooltip-trigger">
                    <span className="material-icon tooltip-icon link size-s">info</span>
                    <span className="tooltip bottom">
                      <span className="tooltip-container">
                        <p className="size-m tooltip-title">¿Qué potencia fotovoltáica máxima tienes?</p>
                        <p className="size-s">Es la <strong>potencia que te han instalado de paneles solares (Ej: 5,3kW)</strong>, también puedes verlo en tu factura de la instalación o preguntarle directamente a tu instalador si tienes dudas.</p>                        
                      </span>
                    </span>
                  </span>
                </label>

                <fieldset className="icon-wrapper data" data-label="kW">
                  <input type="text" inputMode="decimal" id="potenciaMaximaFV"/>
                </fieldset>
              </fieldset>
              
              <fieldset id="fieldsetTipoTarifa" >  
                <legend>Tipo de tarifa</legend>
                <fieldset className="dropdown">                
                  <div className="icon-wrapper">
                    <select id="selectTipoTarifa" onChange={() => actualizarCampoTarifa()}>
                      <option value="FIJA">Fija</option>
                      <option value="INDEXADA">Indexada</option>                  
                    </select>
                  </div>
                </fieldset> 
              </fieldset>

              <fieldset id="fieldsetPrecioVenta" className=" hidden">
                
                <label className="has-tooltip" htmlFor="labelPrecioVentaKwFV">
                  <span className="label tooltip-label">Tarifa de venta</span>
                  <span className="tooltip-trigger">
                  <span className="material-icon tooltip-icon link size-s">info</span>
                    <span className="tooltip bottom">
                      <span className="tooltip-container">
                        <p className="size-m tooltip-title">¿Precio de venta del kW?</p>
                        <p className="size-s">Es el precio al que tu comercializadora te paga cada KW de excedente energético que vuelcas a la red. Puedes dejarlo en blanco si no lo sabes y aplicaremos el precio medio nacional. Aunque si quieres exactitud te animo a que introduzcas el precio real.</p>                                
                      </span>
                    </span>
                  </span>
                </label>          

                <fieldset className="icon-wrapper data" data-label="€/kWh">
                  <input type="text" inputMode="decimal" id="precioVentaKwFV"/>
                </fieldset>
              </fieldset>  

            </fieldset>

            <fieldset id="fieldsetSubvencion" className="check multiple toggle green">
              <input type="checkbox" id="checkboxSubvencion"/>
              <label className="icon-wrapper has-tooltip" htmlFor="checkboxSubvencion" >
                <span className="label" onClick={(event) => event.preventDefault()}>
                  <span>Subvención</span>
                  <span className="tooltip-trigger">
                    <span className="material-icon tooltip-icon link size-s">info</span>
                    <span className="tooltip top">
                      <span className="tooltip-container"><p className="size-m tooltip-title">Subvención para paneles solares</p><p className="size-s">Si tienes solicitada o te han otorgado ya una subvención para paneles solares marca esta opción.</p></span>
                    </span>
                  </span>
                </span>
              </label>
            </fieldset>

            <fieldset id="fieldsetMonederoSolar" className="check multiple toggle green expandable">
              <div className="toggle-container">
                <input type="checkbox" id="checkboxMonederoSolar" onClick={() => visibilidadOpcionesMonedero()}/>
                <label className="icon-wrapper has-tooltip" htmlFor="checkboxMonederoSolar" >
                  <span className="label" onClick={(event) => event.preventDefault()}>
                    <span>Monedero solar / Batería virtual</span>
                    <span className="tooltip-trigger">
                      <span className="material-icon tooltip-icon link size-s">info</span>
                      <span className="tooltip top">
                        <span className="tooltip-container"><p className="size-m tooltip-title">¿Monedero solar / Baterías virtuales?</p><p className="size-s">Algunas comercializadoras te dan la opción (con coste de 3€ mes aprox) de guardar tu excedente energético en € y eso poder usarlo para bajar tu factura incluso hasta el punto de que te salga una factura 0€ o acumularlo para meses posteriores. Si ya lo tienes activo marca esta opción.</p></span>
                      </span>
                    </span>
                  </span>
                </label>
              </div>
              <div id="opcionesMonederoSolar" className="toggle-additional-content vertical gap-04 hidden">
                <fieldset className="tooltip-parent ">       

                  <div id="fieldsetMonederoSolarGratis" className="toggle-container">
                    <input type="checkbox" id="checkboxMonederoSolarGratis"/>
                    <label className="icon-wrapper has-tooltip toggle" htmlFor="checkboxMonederoSolarGratis" >
                      <span className="label" onClick={(event) => event.preventDefault()}>
                        <span>No me cobran por el servicio</span>
                        <span className="tooltip-trigger">
                          <span className="material-icon tooltip-icon link size-s">info</span>
                          <span className="tooltip top">
                            <span className="tooltip-container"><p className="size-m tooltip-title">¿Servicio gratuito?</p><p className="size-s">El coste de tener este servicio activado ronda los 3€ al mes, si en tu caso te lo ofrecen de forma gratuita marca esta opción.</p></span>
                          </span>
                        </span>
                      </span>
                    </label>
                  </div>

                  <div id="fieldsetCompensacionParcialExcedentes" className="toggle-container">
                    <input type="checkbox" id="checkboxCompensacionParcialExcedentes"/>
                    <label className="icon-wrapper has-tooltip toggle" htmlFor="checkboxCompensacionParcialExcedentes" >
                      <span className="label" onClick={(event) => event.preventDefault()}>
                        <span>No me compensan todos los gastos con el excedente</span>
                        <span className="tooltip-trigger">
                          <span className="material-icon tooltip-icon link size-s">info</span>
                          <span className="tooltip top">
                            <span className="tooltip-container"><p className="size-m tooltip-title">¿Compensación parcial por excedentes?</p><p className="size-s">Algunas comercializadoras compensan toda la factura con excedentes y otras solo una parte. Si la tuya NO aplica la compensación total ni acepta facturas a 0 €, selecciona esta opción.</p></span>
                          </span>
                        </span>
                      </span>
                    </label>
                  </div>

                  <fieldset>              
                    <fieldset className="date">
                        <label htmlFor="labelFechaActivacionMonedero"><b>Fecha de activación</b></label>	
                        <fieldset className="icon-wrapper">
                            <input type="date" id="fechaDesdeActivacionMonedero" name="fechaDesdeActivacionMonedero"/>
                        </fieldset>
                    </fieldset>
                  </fieldset>

                  <fieldset id="fieldsetSaldoMonederoConfiguracionInicial" className=" hidden">                
                    <label className="has-tooltip" htmlFor="labelPrecioVentaKwFV">
                    <span className="label tooltip-label small">Saldo última factura</span>
                    <span className="tooltip-trigger">
                    <span className="material-icon tooltip-icon link size-s">info</span>
                        <span className="tooltip bottom">
                        <span className="tooltip-container">
                            <p className="size-m tooltip-title">Último saldo conocido</p>
                            <p className="size-s">Introduce aquí el saldo de tu monedero solar o batería virtual que aparecía en tu última factura. Si todavía no tienes facturas déjalo a 0 y ya lo actualizarás de nuevo cuando te llegue si fuera necesario.</p>                                
                        </span>
                        </span>
                    </span>
                    </label>          

                    <fieldset className="icon-wrapper data" data-label="EUR">
                      <input type="text" inputMode="decimal" id="saldoMonederoConfiguracionInicial" defaultValue="0"/>
                    </fieldset>

                  </fieldset>  

                </fieldset>
              </div>
            </fieldset>

            <fieldset id="sensorFVFieldsetSinConfigurar">
            <span className="size-l">Monitor de los paneles solares</span>
            <p id="textoIntroMonitorFV">Aquí debes configurar tu inversor o medidor de tus paneles solares.</p>
            <button id="sensorFVLink" className="link" onClick={() => initialConfigCommonJS.configurarDispositivo("sensorFV")}><span className="material-icon">add_circle</span>Seleccionar dispositivo</button>
          </fieldset>

          <fieldset id="sensorFVFieldsetSeleccionado" style={{display: "none"}}>
            <span className="size-l">Monitor de los paneles solares</span>
            <div className="selector icon-wrapper no-icon">
              <div className="horizontal vertical-center gap-04 fill" onClick={() => initialConfigCommonJS.configurarDispositivo("sensorFV")}>
                <figure className="avatar size-m"><AppLogoImg id="sensorFVLogoApp" aplicacion={appSensorFV}/></figure>
                <span id="sensorFVSpan" className="label"></span>
              </div>
              <input type="text" id="sensorFV" style={{display: "none"}}/>
            </div>
          </fieldset>

          </fieldset>


          </form>

          <FormValidationError/>
          
          <WorkflowNavigationButtons step={"FV"} navegar={navegar}/>

        </div>

        { localStorage.getItem("installationConfigurationMode") === null
          ? <WorkflowIlustration illustrationElements={illustrationElements}/>
          : <></>
        }

        <Loader Id="loaderFV" Mensaje=""/>

      </section>

      <AsideMenu selectedLocation={selectedLocation} setSelectedLocation={setSelectedLocation}/>

    </main>
    
  )
}

export default Fv